export default __webpack_public_path__ + "static/media/hnitr.38a989e5.png";